let logoutCallback = null;
let refreshIconCallback = null;
export const setLogoutHandler = (callback) => {
  logoutCallback = callback;
};

export const triggerLogoutHandler = () => {
  if (logoutCallback) {
    logoutCallback();
  }
};

export const setRefreshIconHandler = (callback) => {
  refreshIconCallback = callback;
};

export const triggerRefreshIconHandler = () => {
  if (refreshIconCallback) {
    refreshIconCallback();
  }
};